import { Injectable } from '@angular/core';

import { IDocSLNoInputModel, IDocumentApprovalModel, IDocumentInputModel, IDocumentTemplateInputModel, IDocumentShareModel, IDocumentShareMailModel, IDocumentListInputModel, IDocReceiverStatus,IMSTDocDetailsInputModel, IDocumentRepositoryHistoryInputModel } from 'src/app/ViewModel/DocumentModel';
import { RestApiService } from '../rest-api.service';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from 'src/environments/environment';
import { CommonService } from "src/app/Service/Common.service";
import { EncryptDecryptService } from '../encrypt-decrypt.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class DocumentService {
  private getDocSerialNo = 'RepositoryDocuments/GetDocSerialNo';
  private insertDocument = 'RepositoryDocuments/InsertDocument';
  private downloadTemplate = 'RepositoryDocuments/DownloadTemplate';
  private deleteDoc ="RepositoryDocuments/DeleteDocument";
  private uploadExcel = 'RepositoryDocuments/UploadTemplate';
  private getDocumentListurl = 'RepositoryDocuments/GetDocumentList';
  private getDocumentRevHistoryUrl = 'RepositoryDocuments/GetDocumentRevisionHistory';
  private documentApproval = 'RepositoryDocuments/DocumentApproval';
  private documentById = 'RepositoryDocuments/GetDocumentById';
  private documentElementsById = 'RepositoryDocuments/GetDocumentElementsById';
  private insertSearch = 'RepositoryDocuments/InsertDocumentSearch';
  private removeSearch = 'RepositoryDocuments/RemoveDocumentSearch';
  private searchList = 'RepositoryDocuments/GetDocumentSearchList';
  private shareDoc = 'RepositoryDocuments/UpdateDocumentShare';
  private shareDocMail = 'RepositoryDocuments/SendDocumentShareMail';
  private shareDocList = 'RepositoryDocuments/GetDocumentShareList';
  private getDocumentMsgListurl = 'RepositoryDocuments/GetDocumentMessageList';
  private getDocumentRepositoryhistory ='RepositoryDocuments/GetRepositorySharedDocHistoryList';
  private updateDocumentRepositoryhistory ='RepositoryDocuments/UpdateRepositorySharedDocHistoryList';
  private getMSTDetails = 'RepositoryDocuments/GetMSTDetails';
  private insertMSTDocDetails ='RepositoryDocuments/InsertMSTDocDetails'
  private endPoints = {
   uploadFile: "/RepositoryDocuments/UploadTemplate"
}

  constructor(private _commonService: CommonService,private encryptDecryptService: EncryptDecryptService, private restAPIService: RestApiService, private http: HttpClient, private commonService: CommonService) { }


  /**
   * Generate Serial No based on Document Element Details
   * @param DocSLNo
   */
  public GetDocSerialNo(docInputModel: IDocSLNoInputModel): Observable<any> {
    return this.restAPIService.new_POST(this.getDocSerialNo, docInputModel);
  }

  public InsertDocument(docInputModel: IDocumentInputModel): Observable<any> {
    return this.restAPIService.new_POST(this.insertDocument, docInputModel);
  }

  public DownloadTemplate(docInputModel: IDocumentTemplateInputModel): Observable<any> {
    return this.restAPIService.new_POST(this.downloadTemplate, docInputModel);
  }

  public UploadExcel(docInputModel: Array<any>): Observable<any> {
    return this.restAPIService.new_POST(this.uploadExcel, docInputModel);
  }

  public DocumentApproval(docApprovalModel: IDocumentApprovalModel): Observable<any> {
    return this.restAPIService.new_POST(this.documentApproval, docApprovalModel);
  }

  /**
   * Get org API
   * @param ProjecId, GroupId  50
   */
   public getDocumentList(documentListModel: IDocumentListInputModel): Observable<any> {
    return this.restAPIService.new_POST(this.getDocumentListurl, documentListModel);
  }

  public getDocumentRevisionHistory(documentRevHistoryModel: any): Observable<any> {
    return this.restAPIService.new_POST(this.getDocumentRevHistoryUrl, documentRevHistoryModel);
  }

  public getDocumentById(docInputModel: any): Observable<any> {
    return this.restAPIService.new_POST(this.documentById, docInputModel);
  }

  public getDocumentElementsById(docInputModel: any): Observable<any> {
    return this.restAPIService.new_POST(this.documentElementsById, docInputModel);
  }

  public insertDocumentSearch(docInputModel: any): Observable<any> {
    return this.restAPIService.new_POST(this.insertSearch, docInputModel);
  }

  public removeDocumentSearch(projectId?: number, memberId?: number, searchId?: number): Observable<any> {
    let reqData = {
      'projectId': projectId,
      'memberId': memberId,
      'searchId': searchId
    };
    return this.restAPIService.new_POST(this.removeSearch, reqData);
  }

  public getDocumentSearchList(projectId?: number, memberId?: number): Observable<any> {
    let reqData = {
      'projectId': projectId,
      'memberId': memberId
    };
    return this.restAPIService.new_POST(this.searchList, reqData);
  }

  public DocumentShare(docShareModel: IDocumentShareModel): Observable<any> {
    return this.restAPIService.new_POST(this.shareDoc, docShareModel);
  }

  public DocumentShareMail(docShareModel: IDocumentShareMailModel): Observable<any> {
    return this.restAPIService.new_POST(this.shareDocMail, docShareModel);
  }

  public getDocumentShareList(docId?: number, revision?: string): Observable<any> {
    let reqData = {
      'docId': docId,
      'revisionNo': revision
    }
    return this.restAPIService.new_POST(this.shareDocList, reqData);
  }

  public getDocumentMsgList(docId: number, projectId: number, groupId: number, memberId: any, transType: string,revisionNo: string |null): Observable<any> {
    let reqData = {
      'docId': docId,
      'projectId': projectId,
      'groupId': groupId,
      'memberId': memberId,
      'transType': transType,
      'revisionNo':revisionNo
    };   
    return this.restAPIService.new_POST(this.getDocumentMsgListurl, reqData);
  }

  public DeleteDoc(data:any){
    let resData ={
      "docId": data.docId,
      "revisionNo": data.revisionNo,
      "userId":   data.userId
     }   
   return this.restAPIService.new_POST(this.deleteDoc, resData);
  }
  public GetDocumentRepositoryhistory( docId: number, revision: string) :Observable<any> {
    let reqData = {
      'docId': docId,
      'revisionNo': revision
    }
		return this.restAPIService.new_POST(this.getDocumentRepositoryhistory,reqData );
	}

  public setRepoHistoryStatus(docInputModel: IDocReceiverStatus): Observable<any> {
    return this.restAPIService.new_POST(this.updateDocumentRepositoryhistory, docInputModel);
  }


  public GetMSTDetails(data:any){
    let inputData= {
      "uid":data.uid,
      "jobCode":data.jobCode
    }
    return this.restAPIService.new_POST(this.getMSTDetails, data);
  }


  public InsertMSTDocDetails(MSTDocDetailsInput: IMSTDocDetailsInputModel): Observable<any> {
    return this.restAPIService.new_POST(this.insertMSTDocDetails, MSTDocDetailsInput);
  }

  public UploadDocumentExcelTemplate(formData: FormData): Observable<any> {
    let _apiURL = environment.uriHost + this.endPoints.uploadFile;
    const headers = {
        'X-Requested-With': 'XMLHttpRequest',
        'Authorization': 'Bearer ' + this._commonService.getJWT(),
        'loginAuditNumber': this.encryptDecryptService.decrypt(this._commonService.getLoginAuditNumber())
    }
    return this.http.post<any>(_apiURL, formData, { 'headers': headers });
}
 
}
